export const coachMatchingReleaseV2Enabled = (): boolean =>
  import.meta.env.VITE_COACH_MATCHING_RELEASE_V2 === 'true';
